import store from "../store/index";

let canUseKnowledgeBaseBtn = (route) => {
  let knowledgebase = store.getters.getKnowledgeBase.filter((knowledgeBase) => {
    return knowledgeBase.location_id === route;
  });
  return !!knowledgebase.length;
};
export default { canUseKnowledgeBaseBtn };
